interface IAvatarStub {
  gender: string;
  maleViewBox: string;
  femaleViewBox: string;
  viewBox: string;
  isCurator: boolean;
  isMentor: boolean;
}

enum TypeEnum {
  CURATOR = 'curator',
  MENTOR = 'mentor',
}

export { IAvatarStub, TypeEnum };



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/avatar/components/stub/types.ts